import {Injectable} from '@angular/core';
import {ReportesRequestService} from './request/reportes-request.service';
import {DiagnosticoEntity} from './servicio-solicitud-servicios.service';


@Injectable({
  providedIn: 'root'
})
export class ServicioOrdenamientosService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getProfesionalesOrden(params: ParametrosOrdenamientosEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'ordenamientos/profesionales-orden-medica',
        [params.codigo, {
          ln_unco_admsn: params.unco,
          ln_unco_trnsccn: params.uncoTransaccion || 0
        }]
      );
      return response;

    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getProfesionalesSolicitud(params: ParametrosOrdenamientosEntity, fechaInicio: string,
    fechaFin: string, opcion: number) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'ordenamientos/profesionales-solicitud-medica',
        [params.codigo, {
          ln_fec_ini: fechaInicio,
          ln_fec_fin: fechaFin,
          ln_unco_admsn: params.unco,
          ln_unco_trnsccn: params.uncoTransaccion || 0,
          ln_opcn: opcion
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getServiciosDisponibles(params: ParametrosOrdenamientosEntity, fechaInicio: string,
    fechaFin: string, profesionales: string, opcion: number) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'ordenamientos/suministros',
        [params.codigo, {
          ln_fec_ini: fechaInicio,
          ln_fec_fin: fechaFin,
          ln_unco_admsn: params.unco,
          ln_unco_trnsccn: params.uncoTransaccion || 0,
          lc_unco_prfsnl_ordna: profesionales || '',
          ln_opcn: opcion
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getOrdenesServicios(params: ParametrosOrdenamientosEntity, filtros: FitlrosOrdenServicioEntity) {
    const profesionales = filtros.profesionales.toString();
    const procedimientos = filtros.procedimientos.toString();
    try {
      const response = await this.requestUrl.getRequest(
        'ordenamientos/servicios',
        [params.codigo, {
          ln_fec_ini: filtros.fechaInicio,
          ln_fec_fin: filtros.fechaFin,
          ln_unco_admsn: params.unco,
          ln_unco_trnsccn: params.uncoTransaccion || 0,
          lc_unco_prfsnl_ordna: profesionales || '',
          lc_unco_prcdmnto: procedimientos || '',
          ln_unco_lgn: 0
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getSolicitudesDisponibles(params: ParametrosOrdenamientosEntity, profesionales: string) {
    try {
      const response = await this.requestUrl.getRequest(
        'ordenamientos/escritas-descripcion',
        [params.codigo, {
          ln_unco_admsn: params.unco,
          ln_unco_ps: profesionales,
          ln_unco_trnsccn: params.uncoTransaccion || 0
        }]
      );
      return response;

    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getDatosGenerales(params: ParametrosOrdenamientosEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'ordenamientos/escritas-datos-generales',
        [params.codigo, {
          ln_unco_admsn: params.unco,
          lb_frmto_prmprso: 0,
          ln_unco_trnsccn: params.uncoTransaccion || 0
        }]
      );
      return response;

    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getOrdenesEscritas(params: ParametrosOrdenamientosEntity, ordenes: string,
    profesionales: string) {
    try {
      const response = await this.requestUrl.getRequest(
        'ordenamientos/ordenes-escritas',
        [params.codigo, {
          ln_unco_om: ordenes,
          ln_unco_admsn: params.unco,
          ln_unco_ps: profesionales,
          ln_unco_trnsccn: params.uncoTransaccion || 0
        }]
      );
      return response;

    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getOrdenesMedicamentos(params: ParametrosOrdenamientosEntity, filtros: FiltrosOrdenMedicamentosEntity) {
    const profesionales = filtros.profesionales.toString();
    const suministro = filtros.suministros.toString();
    try {
      const response = await this.requestUrl.getRequest(
        'ordenamientos/medicamentos',
        [params.codigo, {
          ln_fec_ini: filtros.fechaInicio,
          ln_fec_fin: filtros.fechaFin,
          ln_unco_admsn: params.unco,
          ln_unco_trnsccn: params.uncoTransaccion,
          lc_unco_prfsnl_ordna: profesionales,
          lc_unco_smnstro: suministro
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getInfoAdicionalOrdenamiento(params: ParametrosOrdenamientosEntity, uncoProfesional: number) {
    try {
      const response = await this.requestUrl.getRequest(
        'ordenamientos/adicional-info',
        [params.codigo, {
          unco_hc: params.uncoHc,
          unco_profesional: uncoProfesional,
          unco_sede : params.uncoSede
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getDiagnosticosAdicionales(params: ParametrosOrdenamientosEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'ordenamientos/diagnosticos-adicionales',
        [params.codigo, {
          unco_hc: params.uncoHc
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getProfesionalesOrdenesGeneral(params: ParametrosOrdenamientosEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'ordenamientos/profesionales-orden-medica-general',
        [params.codigo, {
          ln_unco_admsn: params.unco,
          ln_unco_trnsccn: params.uncoTransaccion || 0
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getOrdenesGeneral(params: ParametrosOrdenamientosEntity, profesionales: string) {
    try {
      const response = await this.requestUrl.getRequest(
        'ordenamientos/todas-pacientes',
        [params.codigo, {
          ln_unco_admsn: params.unco,
          ln_unco_trnsccn: params.uncoTransaccion,
          lc_unco_prfsnl_sld: profesionales,
          ln_opcn: 2
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  getDatosGeneralesEntity(data: any): DatosGeneralesEntity {
    const datos = data[0];
    const datosGenerales = {} as DatosGeneralesEntity;
    datosGenerales.identificacion = datos['idntfccn'];
    datosGenerales.historiaClinica = datos['hstra_clnca'];
    datosGenerales.paciente = datos['paciente'];
    datosGenerales.afiliado = datos['afiliado'];
    datosGenerales.fechaNac = datos['fcha_ncmnto'];
    datosGenerales.direccion = datos['drccn'];
    datosGenerales.telefono = datos['tlfno'];
    datosGenerales.tipoAfiliado = datos['tpo_afldo'];
    datosGenerales.empresa = datos['emprsa'];
    datosGenerales.sexo = datos['sexo'];
    datosGenerales.estrato = datos['dscrpcn_estrto'];
    datosGenerales.sede = datos['dscrpcn_sde'];
    datosGenerales.puntoAtencion = datos['dscrpcn_pnto_atncn'];
    datosGenerales.fechaAtencion = datos['fcha_atncn'];
    datosGenerales.tipoAtencion = datos['tpo_atncn'];
    datosGenerales.profesional = datos['prfsnl_sld'];
    datosGenerales.identificacionProfesional = datos['idntfccn_prfsnl'];
    datosGenerales.registroMedico = datos['rgstro_mdco'];
    datosGenerales.edad = datos['edd'];
    datosGenerales.entidadEmpresarial = datos['entdd_emprsrl'];
    datosGenerales.especialidad = datos['espcldd'];
    datosGenerales.documento = datos['dcmnto'];
    datosGenerales.lineaProductoHc = datos['dscrpcn_lna_prdcto_hstra_clnca'];
    return datosGenerales;
  }

  getOrdenesEscritasEntity(data: any[]): OrdenEscritaEntity[] {
    return data.map(orden => {
      return {
        orden: orden['no_ordn'],
        fechaOrden: orden['fcha_ordn'],
        descripcion: orden['dscrpcn_ordn'],
        profesional: orden['nmbre_prfsnl_sld'],
        identificacion: orden['nmro_idntfccn'],
        registroMedico: orden['rgstro_mdco'],
        uncoOrden: orden['unco_om'],
        especialidad: orden['especialidad'],
        uncoProfesional: orden['uncoProfesionalesSalud'],
        uncoProfesionalEsp: orden['unco_prfsnls_sld_espcldd']
      } as OrdenEscritaEntity;
    });
  }

  getOrdenesServicioEntity(data: any[]): OrdenServicioEntity[] {
    return data.map(serv => {
      return {
        profesional: serv['nmbre_prfsnl_sld'],
        identificacionProfesional: serv['idntfccn_prfsnl'],
        registroMedico: serv['rgstro_mdco'],
        especialidad: serv['especialidad'],
        consecutivoOrden: serv['cnsctvo_ordns_mdcs_srvcs'],
        fecha: serv['fcha'],
        cantidad: serv['cntdd'],
        frecuencia: serv['frcnca'],
        indicaciones: serv['indccns'],
        codigoProcedimiento: serv['cdgo_prcdmnto'],
        descripcion: serv['dscrpcn'],
        paciente: serv['nom_paciente'],
        fechaNac: serv['fcha_ncmnto'],
        sexo: serv['sexo'],
        direccion: serv['drccn'],
        telefono: serv['tlfno'],
        estrato: serv['estrto'],
        tipoAfiliado: serv['tipo'],
        entidad: serv['entidad'],
        identificacion: serv['idntfccn'],
        numeroAdmision: serv['num_adms'],
        historiaClinica: serv['hst_clnca'],
        edad: serv['edd'],
        sede: serv['sede'],
        pos: serv['tpo_srvco_pos'],
        lineaProducto: serv['unco_lna_prdcto'],
        prefijo: serv['prfjo'],
        puntoAtencion: serv['pnto_atncn'],
        pertinencia: serv['pertinencia']
      } as OrdenServicioEntity;
    });
  }

  getOrdenesMedicamentoEntity(data: any[]): OrdenMedicamentoEntity[] {
    return data.map(serv => {
      return {
        identificacion: serv['idntfccn'],
        historiaClinica: serv['hst_clnca'],
        paciente: serv['nom_paciente'],
        fechaNac: serv['fcha_ncmnto'],
        direccion: serv['drccn'],
        telefono: serv['tlfno'],
        tipoAfiliado: serv['tipo'],
        sexo: serv['sexo'],
        estrato: serv['estrto'],
        sede: serv['sede'],
        puntoAtencion: serv['pnto_atncn'],
        profesional: serv['nom_prfsnl'],
        edad: serv['edd'],
        entidad: serv['entidad'],
        numeroAdmision: serv['num_adms'],
        consecutivoOrden: serv['cnsctvo_ordns_mdcs_smnstrs'],
        fecha: serv['fcha'],
        cantidad: serv['cntdd'],
        cantidadLetras: serv['cantidad_letras'],
        indicaciones: serv['indccns'],
        medicamento: serv['dscrpcn_mdcmnt'],
        uncoMedicamento: serv['uncoMedicamento'],
        uncoTipoMedicamento: serv['unco_tpo_mdcmnts'],
        tipoMedicamento: serv['tpo_mdcmnto'],
        viaAdministracion: serv['via_admnstrcn'],
        dosis: serv['dss'],
        uncoEntidad: serv['unco_entidad'],
        duracion: serv['duracion'],
        descripcionUnidad: serv['DescripcionUnidad'],
        prefijo: serv['prfjo'],
        barrio: serv['brro'],
        municipio: serv['mncpo']
      } as OrdenMedicamentoEntity;
    });
  }

  getInfoOrdenamientoEntity(data: any): InfoOrdenamientoEntity {
    const diagnostico = data['diagnostico'];
    const profesional = data['profesional'];
    return {
      diagnostico: {
        descripcion: diagnostico['dscrpcn'],
        codigoDiagnostico: diagnostico['cdgo_dgnstco'],
        activaDescripcion: diagnostico['actva_dscrpcn']
      },
      diagnosticoRel1: {
        descripcion: diagnostico['dxR1'],
        codigoDiagnostico: diagnostico['cdg1'],
        activaDescripcion: diagnostico['actva_dscrpcnDx1']
      },
      diagnosticoRel2: {
        descripcion: diagnostico['dxR2'],
        codigoDiagnostico: diagnostico['cdg2'],
        activaDescripcion: diagnostico['actva_dscrpcnDx2']
      },
      profesional: {
        nombre: profesional['nmbrs'],
        registroMedico: profesional['rgstro_mdco'],
        especialidad: profesional['especialidad'],
        firmaDigital: profesional['frma_dgtl']
      },
      diasValidez : data['diasValidez']['vldz_ordn_ambltra']
    } as InfoOrdenamientoEntity;
  }

  getOrdenesGeneralEntity(data: any[]): OrdenesGeneralEntity[] {
    return data.map(orden => {
      return {
        ordenamiento: orden['dscrpcn_ordn'],
        consecutivo: orden['cnsctvo_ordn'],
        estadoRegistro: orden['estdo_rgstro'],
        fecha: orden['fcha_ordn'],
        profesional: orden['prfsnl_sld'],
        puntoAtencion: orden['pnto_atncn'],
        unco: orden['unco']
      } as OrdenesGeneralEntity;
    });
  }

  async getMedicamentoControlado(params: ParametrosOrdenamientosEntity, unco_ordn_mdca_smnstros: number) {

    try {
      return await this.requestUrl.getRequest(
        'ordenes-medicas/dataMedicamentoControlado',
        [params.codigo, {
          unco_ordn_mdca_smnstros: unco_ordn_mdca_smnstros
        }]
      );
    } catch (e) {
      console.error(e);
    }
    return null;
  }

  async getAfiliado(params: ParametrosOrdenamientosEntity) {

    try {
      return await this.requestUrl.getRequest(
        'ordenes-medicas/dataAfiliadoMedicamentoControlado',
        [params.codigo, {
          uncoHc: params.uncoHc
        }]
      );
    } catch (e) {
      console.error(e);
    }
    return null;
  }

  async getProfesionalesSaludOrdenamientosMedicamentosControlados(codigo: string, uncoHc: number) {
    try {
      return await this.requestUrl.getFilterRequest(
        'ordenamientos/profesionales-medicamentos-controlados',
        [codigo, {
          uncoHc
        }]
      );

    } catch (e) {
      console.error(e);
    }
    return null;
  }

  async getMedicamentosControlados(codigo: string, uncoHc: number, uncoProfesionalSaludEspec: number) {
    try {
      return await this.requestUrl.getFilterRequest(
        'ordenamientos/medicamentos-controlados',
        [codigo, {
          uncoHc,
          uncoProfesionalSaludEspec
        }]
      );

    } catch (e) {
      console.error(e);
    }
    return null;
  }
}

export interface ParametrosOrdenamientosEntity {
  codigo: string;
  uncoLogin: number;
  unco: number;
  uncoSede: number;
  uncoTransaccion?: number;
  uncoHc?: number;
}

export interface FitlrosOrdenEscritaEntity {
  profesionales: number[];
  solicitudes: number[];
}

export interface FitlrosOrdenServicioEntity {
  fechaInicio: string;
  fechaFin: string;
  profesionales: number[];
  procedimientos: number[];
  impresionServicios: boolean;
  discriminarServicios: boolean;
  discriminarNoPos: boolean;
}

export interface FiltrosOrdenMedicamentosEntity {
  fechaInicio: string;
  fechaFin: string;
  dxAdicionales: number[];
  profesionales: number[];
  suministros: number[];
  impresionMedicamentos: boolean;
  discriminarTipo: boolean;
}

export interface FiltrosMedicamentoControladoEntity {
  profesionalSelected: number;
  medicamentoControlado: number;
  dataItem: any;
}

export interface FiltrosOrdenGeneralEntity {
  fechaInicio: string;
  fechaFin: string;
  dxAdicionales: number[];
  profesionales: number[];
}

interface OrdenInfoGeneral {
  identificacion: string;
  historiaClinica: string;
  paciente: string;
  fechaNac: string;
  direccion: string;
  telefono: string;
  tipoAfiliado: string;
  sexo: string;
  estrato: string;
  sede: string;
  puntoAtencion: string;
  profesional: string;
  edad: string;
}

export interface DatosGeneralesEntity extends OrdenInfoGeneral {
  afiliado: string;
  empresa: string;
  fechaAtencion: string;
  tipoAtencion: string;
  identificacionProfesional: string;
  registroMedico: string;
  especialidad: string;
  documento: string;
  lineaProductoHc: string;
  entidadEmpresarial: string;
}

export interface OrdenEscritaEntity {
  orden: string;
  fechaOrden: string;
  descripcion: string;
  profesional: string;
  identificacion: string;
  registroMedico: string;
  uncoOrden: number;
  firmaDigital: string;
  especialidad: string;
  uncoProfesional: number;
  uncoProfesionalEsp: number;
}

export interface OrdenServicioEntity extends OrdenInfoGeneral {
  identificacionProfesional: string;
  registroMedico: string;
  especialidad: string;
  consecutivoOrden: number;
  fecha: string;
  cantidad: number;
  frecuencia: string;
  indicaciones: string;
  codigoProcedimiento: number;
  descripcion: string;
  entidad: string;
  numeroAdmision: number;
  lineaProducto: number;
  prefijo: string;
  pertinencia: string;
  pos: boolean;
}

export interface OrdenMedicamentoEntity extends OrdenInfoGeneral {
  entidad: string;
  numeroAdmision: number;
  consecutivoOrden: number;
  fecha: string;
  cantidad: number;
  cantidadLetras: string;
  indicaciones: string;
  medicamento: string;
  uncoMedicamento: number;
  uncoTipoMedicamento: number;
  tipoMedicamento: string;
  viaAdministracion: string;
  dosis: string;
  uncoEntidad: number;
  duracion: string;
  descripcionUnidad: string;
  prefijo: string;
  barrio: string;
  municipio: string;
}

export interface InfoOrdenamientoEntity {
  diagnostico: DiagnosticoEntity;
  diagnosticoRel1: DiagnosticoEntity;
  diagnosticoRel2: DiagnosticoEntity;
  profesional: {
    nombre: string;
    registroMedico: string;
    especialidad: string;
    firmaDigital: string;
  };
  diasValidez: any;
}

export interface OrdenesGeneralEntity {
  ordenamiento: string;
  consecutivo: number;
  fecha: string;
  profesional: string;
  puntoAtencion: string;
  estadoRegistro: string;
  unco: number;
}

export interface MedicamentoControladoEntity {
  value: number;
  label: string;
  dataItem: any;
}

export interface FitlrosOrdenMedicamentosControladosEntity {
  profesional: number;
  medicamentoControladoSelected: number;
  dataItem: any;
}

export interface AfiliadoDataOrdenamientosMedicamentosControladosEntity {
    numIdentificacion: string;
    tipoId: string;
    nombres: string;
    primer_apellido: string;
    segundo_apellido: string;
    direccion: string;
    municipio: string;
    departamento: string;
    edad: string;
    tipoAfiliado: string;
    entidad: string;
    telefono: string;
    genero: string;
    empresa: string;
}

export interface DataOrdenamientosMedicamentosControladosEntity {
  firmaDigitalProfesional: string;
  afiliado: AfiliadoDataOrdenamientosMedicamentosControladosEntity;
}
